import type React from 'react';
import { LayoutSection } from './LayoutSection';
import { EstimateSection } from './EstimateSection';
import { AboutBuildingSection } from './AboutBuildingSection';
import { PropertyManagerSection } from './PropertyManagerSection';
import type { Floorplan, Unit } from '../UnitTable';
import * as styles from './unitDetailOverlay.styles';

type UnitDetailSpokeContentProps = {
  unit: Unit;
  floorplan: Floorplan;
  sentinelRef?: React.RefCallback<HTMLDivElement>;
};

export const buildUnitSpecs = (unit: { beds: number; baths: number; sqft: number }): string => {
  const formatBeds = (beds: number): string => {
    if (beds === 0) return 'Studio';
    return `${beds} ${beds === 1 ? 'Bed' : 'Beds'}`;
  };
  const formatBaths = (baths: number): string => `${baths} ${baths === 1 ? 'Bath' : 'Baths'}`;
  const formatSqft = (sqft: number): string => {
    if (!sqft || sqft === 0) return '';
    return `${sqft.toLocaleString('en-US')} sqft`;
  };
  return [formatBeds(unit.beds), formatBaths(unit.baths), formatSqft(unit.sqft)].filter(Boolean).join(' · ');
};

export const UnitDetailSpokeContent = ({ unit, floorplan, sentinelRef }: UnitDetailSpokeContentProps) => {
  const specs = buildUnitSpecs(unit);

  return (
    <div className={styles.sectionsContainer}>
      <div className={styles.unitSummary} ref={sentinelRef} data-panel-summary-sentinel>
        <h3 className={styles.unitSummaryTitle}>Unit {unit.name}</h3>
        <p className={styles.unitSummarySpecs}>{specs}</p>
      </div>
      <LayoutSection unit={unit} floorplan={floorplan} />
      <EstimateSection unitName={unit.name} unitBeds={unit.beds} />
      <AboutBuildingSection />
      <PropertyManagerSection />
    </div>
  );
};
